import { Link } from "react-router-dom";
import { getCourseEnrollUrl } from "../utils/constants";

const CourseCard = ({ course }) => {
  const handleEnroll = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(getCourseEnrollUrl(course.title), "_blank");
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 animate-fade-in">
      <div className="relative">
        <img
          src={course.image}
          alt={course.title}
          className="w-full h-48 object-cover"
        />
        <div className="absolute top-4 right-4 bg-primary-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
          {course.level}
        </div>
      </div>

      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-2">{course.title}</h3>
        <p className="text-gray-600 mb-4 line-clamp-2">{course.tagline}</p>

        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center text-sm text-gray-500">
            <svg
              className="w-4 h-4 mr-1"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                clipRule="evenodd"
              />
            </svg>
            {course.duration}
          </div>
          {/* <div className="flex items-center text-sm text-gray-500">
            <svg
              className="w-4 h-4 mr-1"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z" />
            </svg>
            {course.students} students
          </div> */}
        </div>

        {/* <div className="flex items-center justify-between">
          <div className="text-2xl font-bold text-primary-600">
            ₹{course.price}
          </div>
          <div className="flex gap-2">
            <Link
              to={`/courses/${course.slug}`}
              className="px-5 py-2 border border-primary-600 text-primary-600 rounded-lg hover:bg-primary-50 transition-colors duration-200"
            >
              Learn More
            </Link>
            <button
              onClick={handleEnroll}
              className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors duration-200"
            >
              Enroll Now
            </button>
          </div>
        </div> */}

        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
          {/* Price (top on mobile) */}
          {/* <div className="text-xl sm:text-2xl font-bold text-primary-600">
            ₹{course.price}
          </div> */}

          {/* Buttons (full width on mobile, side-by-side on sm+) */}
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
            <Link
              to={`/courses/${course.slug}`}
              className="w-full sm:w-auto px-4 py-2.5 text-center border border-primary-600 text-primary-600 rounded-lg hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap"
            >
              Learn More
            </Link>

            <button
              onClick={handleEnroll}
              className="w-full sm:w-auto px-4 py-2.5 text-center bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors duration-200 whitespace-nowrap"
            >
              Enroll Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
